import { Route, BrowserRouter, Routes } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { CheckoutContent } from './CheckoutContent';
import { ApmDynamicPage } from './components/ApmDynamicPage/ApmDynamicPage';
import { PaymentStatusPage } from './pages/PaymentStatusPage';
import { ErrorScreenFallbackRender } from './components/ErrorScreen/ErrorScreen';
import { StripePaymentHandlerPage } from './pages/StripePaymentHandlerPage';
import { SubscriptionCheckoutContent } from './SubscriptionCheckoutContent';

export const Checkout = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary FallbackComponent={ErrorScreenFallbackRender}>
        <Routes>
          <Route path="/apm-dynamic-page" element={<ApmDynamicPage />} />
          {/* iOS <= 16 Apple Pay fallback tab: top-level checkout seeded from
              the opener via postMessage (see utils/applePayTabFallback.ts). */}
          <Route path="/apple-pay/:token" element={<CheckoutContent />} />
          {/* Chargebee subscription checkout. Declared above /:token, which
              matches a single segment only, so there is no collision. */}
          <Route path="/subscriptions/:token" element={<SubscriptionCheckoutContent />} />
          <Route path="/:token" element={<CheckoutContent />} />
          <Route path="/status/:sessionId/:orderId" element={<PaymentStatusPage />} />
          <Route path="/" element={<CheckoutContent />} />
          <Route path="/handle-payment/:clientSecret/:publishableKey" element={<StripePaymentHandlerPage />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};
